import React from 'react';
import { siteUrl } from '@utils/siteConfig';

export const HOME_VIDEO_LINK = `${siteUrl}/videos/home.webm`;

export const leftHandServices = [
  {
      name: 'Maßgeschneiderte Softwareentwicklung',
      url: 'services/development/',
      icon: '/images/icons/development-icon.svg',
      content: (
          <ul>
              <li>
                  <span className="font-600">Webanwendungen</span>
                  <p className="pl-4">Frontend</p>
                  <p className="pl-4">Backend</p>
              </li>
              <li className="mt-4">
                  <span className="font-600">Mobile Anwendungen</span>
                  <p className="pl-4">Native</p>
                  <p className="pl-4">Cross-Plattform</p>
              </li>
          </ul>
      ),
  },
  {
      name: 'Qualitätssicherung & Testen',
      url: 'services/testing/',
      icon: '/images/icons/testing-icon.svg',
      content: (
          <ul>
              <li className="mb-2">Manuelles Testen</li>
              <li className="mb-2">Automatisiertes Testen</li>
              <li>Unit Testing</li>
          </ul>
      ),
  },
  {
      name: 'Internet der Dinge (IoT)',
      url: 'services/iot/',
      icon: '/images/icons/iot-icon.svg',
      content: (
          <ul>
              <li className="mb-2">IoT Protokolle & Standards</li>
              <li>Hardware Design & Entwicklung</li>
          </ul>
      ),
  },
  {
      name: 'Integrationen',
      url: 'services/integrations/',
      icon: '/images/icons/integrations-icon.svg',
      content: (
          <ul>
              <li className="mb-2">Systemintegration</li>
              <li>Sensorintegrationen</li>
          </ul>
      ),
  },
];

export const rightHandServices = [
  {
      name: 'UI/UX Design',
      url: 'services/design/',
      icon: '/images/icons/design-icon.svg',
      content: (
          <ul>
              <li className="mb-2">Forschung</li>
              <li className="mb-2">Konzept</li>
              <li className="mb-2">Softwarearchitektur</li>
              <li>UX Design Dienstleistungen</li>
          </ul>
      ),
  },
  {
      name: 'Standorte und Asset-Tracking',
      url: 'services/location-and-asset-tracking/',
      icon: '/images/icons/location-assets-icon.svg',
      content: (
          <ul>
              <li className="mb-2">Maßgeschneiderte Besucheranalyse</li>
              <li>Maßgeschriebenes Asset-Tracking</li>
          </ul>
      ),
  },
  {
      name: 'Dediziertes Team',
      url: 'services/dedicated-team/',
      icon: '/images/icons/dedicated-team-icon.svg',
      content: (
          <p>
              Ein dediziertes Team wird entsprechend der definierten Bedürfnisse des Kunden ausgewählt.
          </p>
      ),
  },
  {
      name: 'Personalverstärkung',
      url: 'services/staff-augmentation/',
      icon: '/images/icons/staff-augmentation-icon.svg',
      content: (
          <p>
              Es ist ein Outsourcing-Modell, das es Ihnen ermöglicht, Ihr bestehendes Team mit externen Entwicklern zu verstärken.
          </p>
      ),
  },
];


